var render = function render(){var _vm=this,_c=_vm._self._c;return _c('sidebar-naf',{attrs:{"nav-items":_vm.items,"logo-src":require(`./assets/logo.png`),"logo-mini-src":require(`./assets/logo.png`)}})
}
var staticRenderFns = []

export { render, staticRenderFns }